import { PaymentService } from 'src/app/angularJS/services/payments/payments.service';
import { ChargeAccountService } from 'src/app/angularJS/services/charge-account/charge-account.service';


/**
 * The entry point the charge accounts module
 */
export const initialise = () => {

  const getPaymentRequest = ($stateParams, paymentService: PaymentService, $q: ng.IQService) => {
    const deferred = $q.defer();
    const paymentRequestId = $stateParams.paymentRequestId;

    paymentService.getPaymentRequest(paymentRequestId).then((paymentRequest) => {
      deferred.resolve(paymentRequest);
    });

    return deferred.promise;
  };
  getPaymentRequest.$inject = ['$stateParams', 'paymentService', '$q'];

  const getChargeAccountResponse = ($stateParams, chargeAccountService: ChargeAccountService, $q: ng.IQService): ng.IPromise<InterACT.Interfaces.ChargeAccounts.ChargeAccountResponse> => {
    const deferred = $q.defer<InterACT.Interfaces.ChargeAccounts.ChargeAccountResponse>();
    const chargeAccountId = $stateParams.chargeAccountId;

    chargeAccountService.getChargeAccount(chargeAccountId).then((response) => {
      if (response.chargeAccount) {
        deferred.resolve(response);
        return;
      }

      deferred.reject();
    });
    return deferred.promise;
  };
  getChargeAccountResponse.$inject = ['$stateParams', 'chargeAccountService', '$q'];

  const getChargeAccount = ($stateParams, chargeAccountService: ChargeAccountService, $q: ng.IQService) => {
    const deferred = $q.defer();

    getChargeAccountResponse($stateParams, chargeAccountService, $q).then((response) => {
      if (response.chargeAccount) {
        deferred.resolve(response.chargeAccount);
        return;
      }

      deferred.reject();
    });

    return deferred.promise;
  };
  getChargeAccount.$inject = ['$stateParams', 'chargeAccountService', '$q'];

  angular.module('app.charge-account').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');

    $stateProvider.state('charge-account-summary', {
      url: '/charge-account/:chargeAccountId/summary',
      templateUrl: 'app/angularJS/features/abt/charge-account/summary/charge-account-summary.html',
      controller: 'chargeAccountSummaryController',
      controllerAs: 'vm',
      params: {
        chargeAccountId: undefined
      },
      resolve: {
        chargeAccountResponse: getChargeAccountResponse
      },
      data: {
        selectedTab: 0
      },
      parent: 'common'
    }).state('charge-account-payments', {
      url: '/charge-account/:chargeAccountId/payments',
      templateUrl: 'app/angularJS/features/abt/charge-account/payments/charge-account-payments.html',
      controller: 'chargeAccountPaymentsController',
      controllerAs: 'vm',
      params: {
        chargeAccountId: undefined
      },
      resolve: {
        chargeAccount: getChargeAccount
      },
      data: {
        selectedTab: 2
      },
      parent: 'common'
    }).state('charge-account-journeys', {
      url: '/charge-account/:chargeAccountId/journeys',
      templateUrl: 'app/angularJS/features/abt/charge-account/journeys/charge-account-journeys.html',
      controller: 'chargeAccountJourneysController',
      controllerAs: 'vm',
      params: {
        chargeAccountId: undefined
      },
      resolve: {
        chargeAccount: getChargeAccount
      },
      data: {
        selectedTab: 1
      },
      parent: 'common'
    }).state('charge-account-products', {
      url: '/charge-account/:chargeAccountId/products',
      templateUrl: 'app/angularJS/features/abt/charge-account/products/charge-account-products.html',
      controller: 'chargeAccountProductsController',
      controllerAs: 'vm',
      params: {
        chargeAccountId: undefined
      },
      resolve: {
        chargeAccount: getChargeAccount
      },
      data: {
        selectedTab: 3
      },
      parent: 'common'
    }).state('charge-account-payment-details', {
      url: '/charge-account/:chargeAccountId/payments/:paymentRequestId',
      templateUrl: 'app/angularJS/features/abt/charge-account/payments/payment-details/charge-account-payment-details.html',
      controller: 'chargeAccountPaymentDetailsController',
      controllerAs: 'vm',
      params: {
        chargeAccountId: undefined,
        paymentRequestId: undefined
      },
      resolve: {
        paymentRequest: getPaymentRequest,
        chargeAccount: getChargeAccount
      },
      parent: 'common'
    }).state('charge-account-statement', {
      url: '/charge-account/:chargeAccountId/statement',
      templateUrl: 'app/angularJS/features/abt/charge-account/statement/charge-account-statement.html',
      controller: 'chargeAccountStatementController',
      controllerAs: 'vm',
      params: {
        chargeAccountId: undefined
      },
      resolve: {
        chargeAccount: getChargeAccount
      },
      data: {
        selectedTab: 4
      },
      parent: 'common'
    });

    $urlRouterProvider.otherwise('/');
  }]);
};